/* eslint-disable jira/filename-case */
export const DELAY_PERIOD_MARK_PREFIX = 'event-delay-controller.';
export const DELAY_PERIOD_MARK_START: 'event-delay-controller.start' = `${DELAY_PERIOD_MARK_PREFIX}start`;
export const DELAY_PERIOD_MARK_END: 'event-delay-controller.end' = `${DELAY_PERIOD_MARK_PREFIX}end`;
